import React, { useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const HeroSection = () => {
  // New state for zip code check
  const [zipCode, setZipCode] = useState('');
  const [zipCheckResult, setZipCheckResult] = useState<null | boolean>(null);
  const [shippingAmount, setShippingAmount] = useState<number | null>(null);
  const [isCheckingZip, setIsCheckingZip] = useState(false);
  // Zip code to shipping amount mapping
  const zipCodeMapping: Record<string, number> = {
    '30112': 50,
    '30116': 50,
    '30117': 50,
    '30118': 50,
    '30119': 50,
    '30179': 25,
    '30180': 0,
    '30102': 50,
    '30188': 50,
    '30189': 50,
    '30236': 25,
    '30237': 25,
    '30238': 25,
    '30250': 50,
    '30260': 50,
    '30273': 50,
    '30274': 25,
    '30287': 25,
    '30288': 25,
    '30296': 25,
    '30297': 25,
    '30298': 25,
    '30320': 25,
    '31192': 25,
    '30060': 25,
    '30061': 25,
    '30062': 25,
    '30063': 25,
    '30064': 25,
    '30065': 25,
    '30066': 25,
    '30067': 25,
    '30068': 25,
    '30069': 25,
    '30080': 25,
    '30081': 25,
    '30082': 25,
    '30090': 25,
    '30101': 50,
    '30106': 0,
    '30111': 0,
    '30126': 0,
    '30127': 0,
    '30144': 25,
    '30152': 25,
    '30156': 25,
    '30160': 25,
    '30168': 0,
    '30339': 0,
    '31139': 0,
    '30263': 25,
    '30264': 25,
    '30265': 25,
    '30271': 25,
    '30276': 50,
    '30021': 25,
    '30030': 25,
    '30031': 25,
    '30032': 25,
    '30033': 25,
    '30034': 25,
    '30035': 25,
    '30036': 25,
    '30037': 25,
    '30038': 25,
    '30058': 25,
    '30072': 25,
    '30074': 25,
    '30079': 25,
    '30083': 25,
    '30084': 50,
    '30085': 50,
    '30086': 25,
    '30087': 25,
    '30088': 25,
    '30307': 0,
    '30316': 0,
    '30317': 0,
    '30319': 0,
    '30322': 0,
    '30329': 0,
    '30333': 0,
    '30338': 0,
    '30340': 0,
    '30341': 0,
    '30345': 0,
    '30346': 0,
    '30356': 0,
    '30359': 0,
    '30360': 0,
    '30362': 0,
    '30366': 0,
    '31119': 0,
    '31141': 0,
    '31145': 0,
    '31146': 0,
    '39901': 0,
    '30122': 0,
    '30133': 0,
    '30134': 0,
    '30135': 0,
    '30154': 0,
    '30187': 0,
    '30205': 25,
    '30214': 25,
    '30215': 25,
    '30269': 25,
    '30270': 25,
    '30290': 25,
    '31169': 25,
    '30022': 50,
    '30023': 50,
    '30075': 50,
    '30076': 50,
    '30077': 50,
    '30213': 0,
    '30268': 25,
    '30272': 25,
    '30291': 0,
    '30301': 0,
    '30302': 0,
    '30303': 0,
    '30304': 0,
    '30305': 0,
    '30306': 0,
    '30308': 0,
    '30309': 0,
    '30310': 0,
    '30311': 0,
    '30312': 0,
    '30313': 0,
    '30314': 0,
    '30315': 0,
    '30318': 0,
    '30321': 0,
    '30324': 0,
    '30325': 0,
    '30326': 0,
    '30327': 0,
    '30328': 0,
    '30331': 0,
    '30332': 0,
    '30334': 0,
    '30336': 0,
    '30337': 0,
    '30342': 0,
    '30343': 0,
    '30344': 0,
    '30348': 0,
    '30349': 0,
    '30350': 0,
    '30353': 0,
    '30354': 0,
    '30355': 0,
    '30357': 0,
    '30358': 0,
    '30361': 0,
    '30363': 0,
    '30364': 0,
    '30368': 0,
    '30369': 0,
    '30370': 0,
    '30371': 0,
    '30374': 0,
    '30375': 0,
    '30377': 0,
    '30378': 0,
    '30380': 0,
    '30384': 0,
    '30385': 0,
    '30388': 0,
    '30392': 0,
    '30394': 0,
    '30396': 0,
    '30398': 0,
    '31106': 0,
    '31107': 0,
    '31126': 0,
    '31131': 0,
    '31136': 0,
    '31150': 0,
    '31156': 0,
    '31193': 0,
    '31195': 0,
    '31196': 0,
    '30026': 50,
    '30029': 50,
    '30039': 50,
    '30042': 50,
    '30043': 50,
    '30044': 50,
    '30045': 50,
    '30046': 50,
    '30047': 50,
    '30048': 50,
    '30049': 50,
    '30071': 50,
    '30078': 50,
    '30091': 50,
    '30092': 50,
    '30093': 50,
    '30095': 50,
    '30515': 50,
    '30518': 50,
    '30519': 50,
    '30531': 50,
    '30228': 50,
    '30248': 50,
    '30252': 50,
    '30253': 50,
    '30281': 25,
    '30294': 25,
    '30132': 25,
    '30141': 25,
    '30157': 25,
    '30012': 50,
    '30013': 50,
    '30094': 50
  };
  // Function to check if zip code is in service area
  const checkZipCode = (e: React.FormEvent) => {
    e.preventDefault();
    if (!zipCode || zipCode.length < 5) {
      alert('Please enter a valid zip code');
      return;
    }
    setIsCheckingZip(true);
    // Simulate API call with timeout
    setTimeout(() => {
      // Check if the zip code exists in our mapping
      const shipping = zipCodeMapping[zipCode];
      if (shipping !== undefined) {
        setZipCheckResult(true);
        setShippingAmount(shipping);
      } else {
        setZipCheckResult(false);
        setShippingAmount(null);
      }
      setIsCheckingZip(false);
    }, 800);
  };
  return <div className="w-full bg-gradient-to-r from-primary-50 via-secondary-50 to-primary-50" data-id="element-195">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-12" data-id="element-196">
        <div className="flex justify-center mb-8" data-id="element-197">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4VmNYvHZzkjgPETo7E9Qew/Toddler-Time-Logo-nobackground-300x286.png" alt="Toddler Time Soft Play Rental & More Logo" className="w-48 md:w-64 h-auto" data-id="element-198" />
        </div>
        {/* Hero Section */}
        <div className="flex flex-col lg:flex-row items-center gap-8 mb-16" data-id="element-199">
          <div className="lg:w-1/2 text-left" data-id="element-200">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-700 leading-tight" data-id="element-201">
              Unforgettable
              <br data-id="element-202" />
              Play Experiences
              <br data-id="element-203" />
              For Little
              <br data-id="element-204" />
              Adventurers!
            </h1>
            <p className="mt-6 text-lg text-gray-600 max-w-xl" data-id="element-205">
              Transform any space into a magical playground with our premium
              soft play rentals for toddlers and young children.
            </p>
            <div className="mt-8 flex flex-wrap gap-4" data-id="element-206">
              <Link to="/contact" className="inline-flex items-center px-8 py-3 bg-secondary-500 text-white rounded-full font-medium text-lg shadow-lg hover:bg-secondary-600 transition-all" onClick={() => window.scrollTo(0, 0)} data-id="element-207">
                Book Now
              </Link>
              <a href="#services" className="inline-flex items-center px-8 py-3 bg-primary-500 text-white border border-primary-500 rounded-full font-medium text-lg hover:bg-primary-600 transition-all" data-id="element-208">
                View Packages
              </a>
            </div>
          </div>
          <div className="lg:w-1/2" data-id="element-209">
            <div className="relative" data-id="element-210">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a8JZZ9D2Nz2C5mrhGUsMe6/77BCF6CB-EA89-44A4-BDDF-18A46698D723-1024x768.jpg" alt="Colorful outdoor play setup with bounce house and soft play equipment" className="w-full h-auto rounded-3xl shadow-xl" data-id="element-211" />
              <div className="absolute -bottom-4 -right-4 bg-primary-100 text-primary-700 px-6 py-3 rounded-full font-medium shadow-md animate-bounce" data-id="element-212">
                Safe & Fun!
              </div>
            </div>
          </div>
        </div>
        {/* Zip Code Check Section */}
        <div className="max-w-2xl mx-auto bg-secondary-50 rounded-lg shadow-lg p-6 border border-gray-100" data-id="element-213">
          <h3 className="text-xl font-semibold text-primary-500 mb-4" data-id="element-214">
            Are You in Our Delivery Zone?
          </h3>
          <form onSubmit={checkZipCode} className="flex items-end space-x-4" data-id="element-215">
            <div className="flex-grow" data-id="element-216">
              <label htmlFor="zipCode" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-217">
                Enter Your Zip Code to find out!
              </label>
              <input type="text" id="zipCode" name="zipCode" value={zipCode} onChange={e => setZipCode(e.target.value)} maxLength={5} pattern="[0-9]{5}" placeholder="e.g. 30303" className="py-3 px-4 block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 border-gray-300 rounded-md" data-id="element-218" />
            </div>
            <button type="submit" disabled={isCheckingZip} className="px-4 py-3 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-500 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50" data-id="element-219">
              {isCheckingZip ? 'Checking...' : 'Check'}
            </button>
          </form>
          {zipCheckResult !== null && <div className={`mt-4 p-3 rounded-md ${zipCheckResult ? 'bg-green-50' : 'bg-red-50'}`} data-id="element-220">
              {zipCheckResult ? <div className="flex items-center" data-id="element-221">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-222" />
                  <span className="text-green-700" data-id="element-223">
                    Great news! We deliver to your area{' '}
                    {shippingAmount === 0 ? 'for free!' : `for $${shippingAmount}.`}
                  </span>
                </div> : <div className="flex items-center" data-id="element-224">
                  <XIcon className="h-5 w-5 text-red-500 mr-2" data-id="element-225" />
                  <span className="text-red-700" data-id="element-226">
                    Sorry, we currently do not deliver to this area.
                  </span>
                </div>}
            </div>}
        </div>
      </div>
    </div>;
};